var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "8px",
    viewBox: "0 0 12 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/ic_arrow",
    transform: "translate(-4.000000, -6.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_arrow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2724603,10.1848282 L7.93272336,15.5245652 C7.82710086,15.6383844 7.72109423,15.6386267 7.61470348,15.5252919 C7.00401059,14.8747398 6.67875257,14.5957362 6.67875257,14.5874619 C6.56758054,14.4604569 6.57010566,14.3467597 6.68632794,14.2463704 L10.7758665,10.1568319 C10.872207,10.0158066 10.872736,9.87531038 10.7774534,9.73534309 C10.7763955,9.73534309 9.41700523,8.37595283 6.69928265,5.65717231 C6.55238638,5.53825899 6.55505942,5.41072719 6.70730177,5.27457694 C6.70730177,5.27457694 7.61470348,4.36115531 7.6207234,4.36115531 C7.73520618,4.28946919 7.84257836,4.2944639 7.94283994,4.37613944 C11.4957676,7.92906709 13.2722314,9.70553092 13.2722314,9.70553092 C13.4138522,9.86537299 13.4139285,10.0251388 13.2724603,10.1848282 Z",
    id: "Shape",
    transform: "translate(9.984792, 9.960502) rotate(-270.000000) translate(-9.984792, -9.960502) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrow);
export default __webpack_public_path__ + "static/media/ic-arrow.6197d69c.svg";
export { ForwardRef as ReactComponent };